import { useI18n } from 'vue-i18n';
import { storeLocale } from '@/plugins/i18n';
import { httpService } from '@/services/HttpService';
import { useAuthStore } from '@/stores/auth';

export type SupportedLocale = 'en' | 'es' | 'pt';

const SUPPORTED_LOCALES: SupportedLocale[] = ['en', 'es', 'pt'];

export function useLocaleSwitch() {
  const { locale } = useI18n();
  const authStore = useAuthStore();

  async function switchLocale(code: SupportedLocale): Promise<void> {
    if (!SUPPORTED_LOCALES.includes(code)) {
      console.warn('[LanguageSwitcher] Invalid locale:', code);
      return;
    }

    locale.value = code as typeof locale.value;
    storeLocale(code);

    if (authStore.isAuthenticated) {
      try {
        await httpService.put<{ message: string; locale: SupportedLocale }>('/user/locale', { locale: code });
      } catch (error) {
        console.error('[LanguageSwitcher] Error syncing locale:', error);
      }
    }
  }

  return { switchLocale };
}
